
import React from "react";

function WhatWeDo() {
  const items = [
    {
      title: "Web Development",
      description: "High-performance, scalable websites built with modern tech.",
      icon: "ri-code-s-slash-line",
      gradient: "from-purple-500 to-indigo-500",
    },
    {
      title: "Mobile App Development",
      description: "Smooth, fast and secure Android & iOS applications.",
      icon: "ri-smartphone-line",
      gradient: "from-pink-500 to-rose-500",
    },
    {
      title: "Digital Marketing",
      description: "ROI-focused strategies to grow your brand online.",
      icon: "ri-megaphone-line",
      gradient: "from-emerald-500 to-teal-500",
    },
    {
      title: "UI/UX Design",
      description: "Clean, intuitive designs that convert users into clients.",
      icon: "ri-brush-line",
      gradient: "from-yellow-500 to-orange-500",
    },
  ];

  return (
    <section className="relative  py-20 ">
      <h1 className="text-center text-4xl md:text-6xl font-semibold mb-16 text-secondary">
  What <span className="text-gradient">We Do?</span>
</h1>


      <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-10 px-6 md:px-16 ">
        {items.map((item, index) => (
          <div
            key={index}
            className="group relative bg-slate-950 backdrop-blur-xl border border-white/10 
                       rounded-2xl p-8 text-center transition-all duration-500
                       hover:-translate-y-4 hover:shadow-[0_20px_60px_rgba(0,0,0,0.5)]"
          >
            {/* Floating Icon */}
            <div
              className={`absolute -top-8 left-1/2 -translate-x-1/2 
                          w-16 h-16 rounded-full bg-gradient-to-r ${item.gradient}
                          flex items-center justify-center text-white text-3xl
                          shadow-lg transition-transform duration-500
                          group-hover:scale-110`}
            >
              <i className={item.icon}></i>
            </div>

            {/* Content */}
            <div className="mt-10">
              <h2 className="text-xl font-semibold text-white mb-3">
                {item.title}
              </h2>
              <p className="text-gray-400 text-sm leading-relaxed">
                {item.description}
              </p>
            </div>

            {/* Glow Effect */}
            <div
              className={`absolute inset-0 rounded-2xl opacity-0 group-hover:opacity-20
                          bg-gradient-to-r ${item.gradient}
                          blur-2xl transition duration-500`}
            ></div>
          </div>
        ))}
      </div>
    </section>
  );
}

export default WhatWeDo;
